// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__kwwpJ","paramInput":"JobSimulator_paramInput__2CtE4","input":"JobSimulator_input__1aGiA"};